import { useState, useEffect } from "react";
import axios from "axios";
import { Divider } from "@mui/material";

import clock_3 from "../../../assets/images/NewEvent/clock_3.svg";
import user_status from "../../../assets/images/NewEvent/user_status.svg";
import list from "../../../assets/images/NewEvent/list.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/autoplay";

import { Navigation, Autoplay } from "swiper/modules";

function extractFirstImageAndText(htmlContent) {
  const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
  const match = imgRegex.exec(htmlContent);

  let firstImage = null;
  if (match) {
    firstImage = match[1];
  }

  const textWithoutFirstImage = htmlContent.replace(imgRegex, "");
  return { text: textWithoutFirstImage, firstImage };
}

function getCategoryName(categories, ids) {
  const arrIds = ids
    ? ids
        .split(",")
        .map((num) => Number(num))
        .filter((n) => n > 0)
    : [];
  const cat = categories.find(
    (item) => item.id == (arrIds.length > 0 ? arrIds[0] : 0)
  );
  return cat?.name ?? "";
}

const fetchDataCategory = async () => {
  const response = await axios.get(
    "https://api-bluerise.bluerise.com.vn/category/get-all"
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

const fetchDataNews = async () => {
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/get-publish",
    {
      keyword: "",
      status: 2,
      pageNum: 1,
      pageSize: 50,
    }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

function renderNewsRow(categories, newsData) {
  let { text, firstImage } = extractFirstImageAndText(newsData.shortContent);
  return (
    <div className="w-full gap-3 hover:border hover:border-blue-500 rounded-[8px] md:h-[65vh] lg:h-auto border border-solid border-gray-300 shadow-custom-light">
      <div className="w-full flex flex-col gap-3">
        <div className="overflow-hidden">
          <Link to={`/tintuc-chitiet/${newsData.slug}`}>
            <img
              src={firstImage}
              className="w-full h-auto object-cover rounded-[8px] transform transition-transform duration-300 ease-in-out hover:scale-110"
            />
          </Link>
        </div>
        <div className="w-full px-[24px] py-[16px] flex flex-col gap-3">
          <div className="md:h-16">
            <p className="text-[16px] font-semibold text-[#1F1F1F] hover:text-[#053CC8] cursor-pointer">
              <Link to={`/tintuc-chitiet/${newsData.slug}`}>
                <p className="text-[#053CC8]">{newsData.title}</p>
              </Link>
            </p>
          </div>

          <div className="flex items-center justify-between w-full md:flex-col lg:flex-row md:gap-1 md:items-center md:justify-center md:h-40 lg:h-10">
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={user_status} alt="bg" />
              </div>
              <p className="font-extrabold md:text-[16px]">{newsData.author}</p>
            </div>
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={clock_3} alt="mk" />
              </div>
              <p className="font-extrabold md:text-[16px]">
                {new Date(newsData.publishDate).toLocaleDateString()}
              </p>
            </div>
          </div>
          <div>
            <Divider />
          </div>

          <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
            <div>
              <img src={list} alt="nj" />
            </div>
            <p>{getCategoryName(categories, newsData.categories)}</p>
          </div>

          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="h-32 md:h-36 overflow-auto overflow-x-hidden"
          />
        </div>
      </div>
    </div>
  );
}

export default function HomeNewEvent() {
  const [activeTab, setActiveTab] = useState("latest");
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState(null);
  const [articles, setArticles] = useState([]);

  const itemsPerPage = 1;
  const totalPages = Math.ceil(articles.length / itemsPerPage);

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  // Chỉ hiển thị tối đa 3 số trang: trang hiện tại và 2 trang lân cận (nếu có)
  const renderPageNumbers = () => {
    let pageNumbers = [];
    const maxVisiblePages = 3; // Giới hạn số trang hiển thị

    // Tính toán trang bắt đầu và kết thúc
    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Điều chỉnh nếu số trang hiển thị chưa đủ 3
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`px-3 py-1 rounded-lg ${
            i === currentPage
              ? "bg-blue-100 text-blue-500 font-semibold"
              : "text-gray-700"
          }`}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const currentArticles = articles.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    fetchDataCategory().then((data) => {
      setCategories(data);
    });
    fetchDataNews().then((data) => {
      setArticles(data);
    });
  }, []);

  return (
    <div className="w-full">
      <div className="container mx-auto p-3">
        <div className="block md:hidden">
          <div className="grid grid-cols-1 w-full items-center gap-5">
            {currentArticles.map((article, index) => (
              <div key={index}>{renderNewsRow(categories, article)}</div>
            ))}
          </div>
          <div className="flex justify-center items-center mt-4 gap-2">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded-lg bg-gray-200 text-gray-700 disabled:bg-gray-100 disabled:text-gray-400"
            >
              Trở về
            </button>
            {renderPageNumbers()}
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="px-3 py-1 rounded-lg bg-gray-200 text-gray-700 disabled:bg-gray-100 disabled:text-gray-400"
            >
              Tiếp theo
            </button>
          </div>
        </div>

        <div className="hidden md:block">
          <Swiper
            spaceBetween={10}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            speed={5000}
            modules={[Autoplay, Navigation]}
          >
            {articles.map((article, index) => (
              <SwiperSlide key={index}>
                {renderNewsRow(categories, article)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
